module.exports = __webpack_public_path__ + "video-thumbnail-privacy-6a17ccc8e2aacc8d49bc818542961fad.jpg";